export default __webpack_public_path__ + "static/media/signout.9311cd8a.svg";